<template>
     <v-layout row align-center justify-center>

          <v-flex xs4 style="padding: 10px;">
               <v-img
                    :src="getImgUrl('call-center-agent')"
                    :lazy-src="getImgUrl('call-center-agent')"
                    width="70"
                    style="float: right;"
                    >
                </v-img>
          </v-flex>

           <v-flex xs6 style="margin: 10px;">

                <div v-if="!productDetail.username && !productDetail.password">
                    <span class="game-expansion-panel-guest-title" style="font-weight: bolder;">{{ $t('game.guest_player_information_title' ) }}</span>
                        <br/>
                    <span class="game-expansion-panel-guest-desc" style="font:small-caption margin-bottom: 7px;">{{ $t('game.guest_player_information_desc' ) }}</span>
                        <br/>
                    <div>
                        <v-btn color="primary" style="padding: 10px;" @click.prevent="$router.push({name: 'Contact'})">
                            {{ $t('game.guest_player_information_button' ) }}
                        </v-btn>
                    </div>
                </div>

                <div v-else>

                    <span class="game-expansion-panel-player-title" style="font-weight: bolder;">{{ $t('game.player_information' ) }}</span>
                    <br/>

                    <div style="margin-top: 7px;">
                        {{ productDetail.username ? productDetail.username: $t('game.pm_message') }}
                        <!--tooltop-->
                        <v-tooltip v-if="productDetail.username" right>
                            <template v-slot:activator="{ on }">
                                <v-icon class='ml-2' v-on="on" @click.prevent="showSnackbar(productDetail.username)" :size=13>file_copy
                                </v-icon>
                            </template>
                            <span>{{ $t('shared.copy') }}</span>
                        </v-tooltip>
                    </div>

                    <div>
                        {{ productDetail.password ? productDetail.password:  $t('game.pm_message') }}
                        <!--tooltop-->
                        <v-tooltip v-if="productDetail.password" right>
                            <template v-slot:activator="{ on }">
                                <v-icon class='ml-1' v-on="on" @click.prevent='showSnackbar(productDetail.password)' :size=14>file_copy
                                </v-icon>
                            </template>
                            <span>{{ $t('shared.copy') }}</span>
                        </v-tooltip>
                    </div>

                </div>

          </v-flex>

        <!--Dialog-->
        <showDialog :dialog="dialog" @DialogChanged="dialog = $event.value" />
    </v-layout>
</template>

<script>
import showDialog from '@/components/Games/Dialog.vue';

export default {
    name: 'Expansion-Pannel',
    props: ["product"],
    data() {
        return {
            dialog: false,
            snackbar: false
        }
    },
    computed: {
        productDetail: function() {
            return this.product;
        }
    },
    components: {
        showDialog,
    },
    methods: {
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        update() {

            this.dialog != this.dialog;

        },
        showSnackbar(copiedText) {

            let input = document.createElement('input');

            document.body.appendChild(input);

            input.value = copiedText;

            input.select();

            try {

                let successful = document.execCommand('copy');

                this.$emit('show', successful);

            } catch (err) {

                alert(this.$t('shared.opp_unable_copy'));

            }

            document.body.removeChild(input);
        }
    }
}
</script>

<style scoped>
.font-size {
    font-size: 10px;
}

.v-card__text {
    padding-bottom: 0px;
}

.game-expansion-panel-guest-title{
    font-size: calc(0.60em + 1.5vmin)
}

.game-expansion-panel-guest-desc{
    font-size: calc(0.35em + 1vmin)
}

.game-expansion-panel-player-title{
    font-size: calc(0.60em + 1.5vmin)
}

@media (max-width: 329px) {
  .game-expansion-panel-guest-title{
    font-size: calc(0.50em + 1.5vmin)
    }

    .game-expansion-panel-guest-desc{
        font-size: calc(0.30em + 1vmin)
    }
}

</style>
